var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9258 5C21.622 5.45522 23.1686 6.34857 24.4104 7.59039C25.6522 8.83221 26.5456 10.3788 27.0008 12.075",
    stroke: "#2A3842",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8867 8.86255C19.9069 9.13348 20.8373 9.66928 21.5836 10.4156C22.33 11.162 22.8658 12.0924 23.1367 13.1125",
    stroke: "#2A3842",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 15.5998C12.5915 17.7248 14.3098 19.4387 16.4375 20.4623C16.5944 20.5366 16.768 20.5688 16.9412 20.5556C17.1143 20.5425 17.2811 20.4845 17.425 20.3873L20.55 18.2998C20.6881 18.2062 20.8476 18.149 21.0137 18.1337C21.1799 18.1184 21.3472 18.1454 21.5 18.2123L27.35 20.7248C27.5499 20.808 27.717 20.9546 27.8254 21.1421C27.9338 21.3296 27.9776 21.5475 27.95 21.7623C27.7646 23.2095 27.0582 24.5395 25.9631 25.5035C24.8679 26.4675 23.459 26.9995 22 26.9998C17.4913 26.9998 13.1673 25.2087 9.97919 22.0206C6.79107 18.8325 5 14.5085 5 9.9998C5.00033 8.54079 5.53227 7.1319 6.49628 6.03674C7.4603 4.94158 8.79033 4.23521 10.2375 4.0498C10.4523 4.02221 10.6702 4.06599 10.8577 4.17441C11.0452 4.28282 11.1918 4.44986 11.275 4.6498L13.7875 10.5123C13.8528 10.6627 13.8802 10.8269 13.8671 10.9904C13.854 11.1539 13.8009 11.3117 13.7125 11.4498L11.625 14.6248C11.5321 14.7684 11.4775 14.9334 11.4666 15.1041C11.4556 15.2748 11.4887 15.4455 11.5625 15.5998V15.5998Z",
    stroke: "#2A3842",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.11f07600cc171a54de17d1d4d13e1605.svg";
export { ForwardRef as ReactComponent };